import type { TableColumns } from '@ohpen/enso-ui';
import { ExclusivitySetDataRow, ExclusivitySetResponse, FieldType } from '@pmp/api';

export const exclusiveSetsColumns: TableColumns<ExclusivitySetResponse> = [
  {
    title: 'pmp.exclusiveProducts.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 250,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.description',
    dataIndex: 'description',
    key: 'description',
    width: 330,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 240,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 240,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firmIds',
    dataIndex: 'firms',
    key: 'firmIds',
    width: 300,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firms',
    dataIndex: 'firms',
    key: 'firms',
    width: 140,
    options: {
      format: {
        type: 'multiValueList',
        ellipsis: { visibleItems: 1 },
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      allowSearch: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

// Change-request rows carry firm ids under `firms`; the list response carries key-and-label pairs under the same name.
export const exclusiveSetsCRColumns: TableColumns<ExclusivitySetDataRow> = [
  {
    title: 'pmp.exclusiveProducts.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 250,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.description',
    dataIndex: 'description',
    key: 'description',
    width: 330,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 240,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 240,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firmIds',
    dataIndex: 'firms',
    key: 'firmIds',
    width: 300,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firms',
    dataIndex: 'firms',
    key: 'firms',
    width: 240,
    options: {
      format: {
        type: 'multiValueList',
        ellipsis: { visibleItems: 1 },
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      allowSearch: true,
      sortSelectedFirst: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
